import { JsonValue } from 'type-fest';

import { TStorageOptions, getItem, removeItem, setItem } from './localStorage';

export class Storage<SavedValue extends JsonValue> {
  key: string;
  options: TStorageOptions;

  constructor(key: string, options: TStorageOptions) {
    this.key = key;
    this.options = options;
  }

  get = (): SavedValue => getItem(this.key, this.options);

  set = (value: SavedValue) => {
    setItem(this.key, value, this.options);
  };

  remove = () => {
    removeItem(this.key, this.options);
  };
}

const storageKeys: {
  [name: string]: {
    key: string;
    options: TStorageOptions;
  };
} = {
  compactPrettyLoad: {
    key: 'ATI_loadsCompactView',
    options: {
      isGlobal: true,
    },
  },
  subscriptionPromoTimestamp: {
    key: 'subscriptionPromoTimestamp',
    options: {
      isGlobal: false,
      isUserSpecific: true,
    },
  },
  subscriptionPromoCounter: {
    key: 'subscriptionPromoCounter',
    options: {
      isGlobal: false,
      isUserSpecific: true,
      type: 'session',
    },
  },
  lastSearchedFilterStorage: {
    key: 'lastSearchedFilter',
    options: {
      isGlobal: false,
      isUserSpecific: true,
    },
  },
  etrnBannerClosedTimestamp: {
    key: 'etrnBannerClosedTimestamp',
    options: {
      isGlobal: false,
      isUserSpecific: true,
    },
  },
  etrnPopupClosedTimestamp: {
    key: 'etrnPopupClosedTimestamp',
    options: {
      isGlobal: false,
      isUserSpecific: true,
    },
  },
  followedLoadsTabOpenCounterStorage: {
    key: 'followedLoadsTabOpenCounter',
    options: {
      isGlobal: false,
      isUserSpecific: true,
    },
  },
};

export const compactPrettyLoadStorage = new Storage<boolean>(
  storageKeys.compactPrettyLoad.key,
  storageKeys.compactPrettyLoad.options,
);

export const subscriptionPromoTimestampStorage = new Storage<number>(
  storageKeys.subscriptionPromoTimestamp.key,
  storageKeys.subscriptionPromoTimestamp.options,
);

export const subscriptionPromoCounterStorage = new Storage<number>(
  storageKeys.subscriptionPromoCounter.key,
  storageKeys.subscriptionPromoCounter.options,
);

export const lastSearchedFilterStorage = new Storage<string>(
  storageKeys.lastSearchedFilterStorage.key,
  storageKeys.lastSearchedFilterStorage.options,
);

export const etrnBannerClosedTimestampStorage = new Storage<number>(
  storageKeys.etrnBannerClosedTimestamp.key,
  storageKeys.etrnBannerClosedTimestamp.options,
);

export const etrnPopupClosedTimestampStorage = new Storage<number>(
  storageKeys.etrnPopupClosedTimestamp.key,
  storageKeys.etrnPopupClosedTimestamp.options,
);

export const followedLoadsTabOpenCounterStorage = new Storage<number>(
  storageKeys.followedLoadsTabOpenCounterStorage.key,
  storageKeys.followedLoadsTabOpenCounterStorage.options,
);
